export enum TelematicsTrailerFilter {
  TRAILER_FREE = 'trailer-free',
  TRAILER_LOADED = 'trailer-loaded',
  TRAILER_LOADED_WAITING = 'trailer-loaded-waiting',
}
